"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var play_triangle = function play_triangle(_ref) {
  var size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, ["size"]);

  return _react["default"].createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "currentColor",
    width: size || "60",
    height: size || "60"
  }, props), _react["default"].createElement("path", {
    d: "M41.5,30l-17,10V20L41.5,30z"
  }));
};

play_triangle.displayName = 'play_triangle';
var _default = play_triangle;
/* tslint:enable */

/* eslint-enable */

exports["default"] = _default;